import axios from 'axios';
import { HttpStatusCode } from 'constant/enum';
import { PAGE_LIST } from 'constant/pages';
import { removeKeyFromLocalStorage } from 'utils/constant';

export const fetchDashboard = ({
  appId,
  appKey,
}: {
  appId: string;
  appKey: string;
}) => {
  return axios.create({
    baseURL: process.env.REACT_APP_DASHBOAD_API,
    timeout: 20000,
    headers: {
      'x-app-id': appId,
      'x-app-key': appKey,
    },
  });
};

export const fetchCheckAuth = (
  appId: string,
  appKey: string,
  dbId: string,
  dbKey: string
) => {
  const path = localStorage.getItem('url');
  return axios.create({
    baseURL: path ?? process.env.REACT_APP_PRIVATE_ID_API,
    timeout: 20000,
    headers: {
      'X-App-Id': appId,
      'X-App-Key': appKey,
      'X-App-Db': dbId,
      'X-App-Db-Key': dbKey,
    },
  });
};

export const fetchClusterDb = (
  appId: string,
  appKey: string,
  dbId: string,
  dbKey: string
) => {
  const path = localStorage.getItem('url');
  const axiosInstance = axios.create({
    baseURL: path ?? process.env.REACT_APP_CLUSTER_DB_API,
    timeout: 20000,
    headers: {
      'X-App-Id': appId,
      'X-App-Key': appKey,
      'X-App-Db': dbId,
      'X-App-Db-Key': dbKey,
    },
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        [HttpStatusCode.Unauthorized, HttpStatusCode.Forbidden].includes(
          error.response?.status
        )
      ) {
        removeKeyFromLocalStorage(['appId', 'appKey', 'dbId', 'dbKey', 'url']);
        document.location.replace(PAGE_LIST.SETTING.pathname());
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default fetch;
